export default "assets/images/bring-0ce2a602.svg";